<script lang="ts" setup>
import useAuthStore from '../../stores/auth';

const emit = defineEmits(['handleLogin']);

const authStore = useAuthStore();

const username = defineModel('username', { default: '', required: true, type: String });
const password = defineModel('password', { default: '', required: true, type: String });

const handleLogin = async () => {
  emit('handleLogin');
};
</script>

<template>
  <div class="relative">
    <el-form ref="filterFormRef" label-position="top" size="default">
      <!-- Email -->
      <el-form-item class="font-bold uppercase" :label="$t('login.email')" prop="username">
        <el-input v-model="username" class="font-normal" type="email" data-cy="email" />
      </el-form-item>

      <!-- Password -->
      <el-form-item class="font-bold uppercase" :label="$t('login.password')" prop="password">
        <el-input v-model="password" class="font-normal" show-password data-cy="password" @keydown.enter="handleLogin" />
      </el-form-item>

      <div>
        <div v-if="authStore.authenticationError.length > 0">
          <div class="fs-12 py-2 text-justify mb-4 px-2 bg-red-100 border border-red-500">
            <span class="text-red-500" data-cy="error">{{ authStore.authenticationError }}</span>
          </div>
        </div>
      </div>

      <!-- Forgot Password -->
      <div class="flex justify-end mb-4">
        <el-button
          link
          class="forgot-password-link underline"
          data-cy="btn-forgot-password"
          @click="$router.push({ name: 'forgotPassword' })"
        >
          {{ $t('login.forgot_password') }}?
        </el-button>
      </div>

      <!-- Button -->
      <el-form-item class="login-button">
        <el-button class="w-full" type="primary" round :loading="authStore.authenticating" data-cy="btn-login" @click="handleLogin">
          <font-awesome-icon :icon="['fal', 'arrow-right-to-bracket']" />
          <span class="ml-2 uppercase">{{ $t('login.login') }}</span>
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<style scoped>
  #login-card{
    box-shadow: 0 0 5px rgba(175,175,175,.5), inset 0 1px 0 hsla(0,0%,100%,.9) !important;
  }

  .forgot-password-link:hover{
    color: #666666 !important;
  }
  .login-button{
    margin-top: 50px;
  }

  .el-input__wrapper{
    background-color: white;
  }
</style>
